import * as R from 'ramda';

import { resetTerms as resetJsonQueryTerms } from './helpers';
import { resetForDay } from './resetForDay';
import { IJsonQuery, TJsonQueryOptionalKeys } from './types';

export function resetTerms(jsonQuery: IJsonQuery) {
  return (terms: TJsonQueryOptionalKeys[]): IJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    if (terms.includes('for_day')) {
      nextJsonQuery = resetForDay(nextJsonQuery)();
    }

    const ignoredTerms = ['for_day'];
    const termsToReset = terms.filter(t => !ignoredTerms.includes(t));
    nextJsonQuery = resetJsonQueryTerms(termsToReset)(nextJsonQuery);

    return nextJsonQuery;
  };
}
